import type { IntlShape } from '@redbubble/next/intl';
import type { ShippingPreference } from '../../types/monolith/cart';
import { messages } from './messages';

export interface GetShippingTitleParams {
  intl: IntlShape;
  shippingMethod: ShippingPreference;
  isShippingEstimated?: boolean;
  flatRateApplied?: boolean;
}

export const getShippingTitle = ({
  intl,
  shippingMethod,
  isShippingEstimated,
  flatRateApplied,
}: GetShippingTitleParams): string => {
  const standardShippingTitle = flatRateApplied
    ? intl.formatMessage(messages.flatRateShipping)
    : intl.formatMessage(
        isShippingEstimated
          ? messages.standardShippingEstimated
          : messages.standardShipping
      );

  const expressShippingTitle = intl.formatMessage(
    isShippingEstimated
      ? messages.expressShippingEstimated
      : messages.expressShipping
  );

  const shippingTitle =
    shippingMethod === 'standard'
      ? standardShippingTitle
      : expressShippingTitle;

  return shippingTitle;
};
